import React from 'react';
import PropTypes from 'prop-types';
import * as styles from './style';

class ActionBtn extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      openNav: false,
      items: props.items,
    };
  }

  onClick = item => {
    this.props.onClick(item);
  };

  renderBtnTitle = () => {
    return (
      <div>
        <span />
        <span />
        <span />
      </div>
    );
  };

  renderBtnItems = (item, i) => {
    const { id } = this.props;
    return (
      <li
        key={i}
        id={`${id}-${item.type}`}
        onClick={e => {
          e.preventDefault();
          this.onClick(item.type);
        }}
        className="item"
      >
        <a>{item.label}</a>
      </li>
    );
  };

  openDropDown = e => {
    e.stopPropagation();
    this.setState({ openNav: !this.state.openNav });
  };

  setRef = (name, node) => (this[name] = node);

  handleClickOutside = event => {
    if (
      this.btnToggleMenuAction &&
      !(
        this.btnToggleMenuAction === event.target || this.btnToggleMenuAction.contains(event.target)
      ) &&
      this.state.openNav
    ) {
      this.openDropDown(event);
    }
  };

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  render() {
    const { id, buttonStyle, dotStyle, hoverStyle, className } = this.props;
    return (
      <styles.ButtonToolbar
        id={id}
        ref={node => this.setRef('btnToggleMenuAction', node)}
        onClick={e => {
          this.openDropDown(e);
        }}
        buttonStyle={buttonStyle}
        dotStyle={dotStyle}
        hoverStyle={hoverStyle}
        className={className}
        type="button"
      >
        {this.renderBtnTitle()}
        <styles.ButtonToolbarNav openDropDown={this.state.openNav}>
          {this.state.items.length ? this.state.items.map(this.renderBtnItems) : null}
        </styles.ButtonToolbarNav>
      </styles.ButtonToolbar>
    );
  }
}

ActionBtn.propTypes = {
  items: PropTypes.array.isRequired,
  classStyle: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

export default ActionBtn;



// WEBPACK FOOTER //
// ./src/components/ActionBtn/index.js